import BreadCrumbs from 'components/breadcrumbs'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import { URL_WORKPLACE } from 'utils/pathUrl'
import TabMapSchema from './TabMapSchema'
import TabMasterItems from './TabMasterItems'

const FindoraItemsManagement = () => {
  const [activeTab, setActiveTab] = useState('master-items')

  const tabs = [
    { key: 'master-items', label: 'Master Items' },
    { key: 'map-schema', label: 'Map Skema' },
  ]

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
  }

  return (
    <div className="w-100 px-3">
      <div className="mt-3">
        <BreadCrumbs breadCrumbActive="Manajemen Barang" />
      </div>

      <Card className="mb-3 border-0 shadow-sm">
        <CardBody>
          <div className="mb-3">
            <h5 className="fw-semibold mb-1">Manajemen Barang</h5>
            <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
              Kelola master items produk dan skema
            </p>
          </div>

          <PMBTabSwitcher
            activeTab={activeTab}
            tabs={tabs}
            onTabChange={handleTabChange}
            boldLabel={false}
            labelSize="regular"
            testId="findora-items-tab"
          />

          <div className="mt-4">
            {activeTab === 'master-items' && <TabMasterItems />}
            {activeTab === 'map-schema' && <TabMapSchema />}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

export default FindoraItemsManagement
